import React from 'react';
import Announcement from '../user/Announcement.jsx';
import { useAutoFont } from '../utils/useAutoFont.js';

export default function Footer({ announcementHeight, announceRef, announceFont, accessibilityNumber, accessibilityWidth, wing }) {
  const [textRef, textFont] = useAutoFont(
    Math.round(Math.min(Math.max(announcementHeight * 0.45, 16), announcementHeight * 0.55)),
    12
  );

  const borderW = Math.max(3, Math.round(announcementHeight * 0.03)); // 3px at 95, 6px at 190
  // Compute an inner height that accounts for border
  const innerHeight = Math.max(announcementHeight - borderW, 40);

  return (
    <div
      style={{
        width: '100%',
        height: announcementHeight,
        boxSizing: 'border-box',
        borderTop: `${borderW}px solid #fff`,
        backgroundColor: '#000',
        color: '#fff',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <div
        ref={textRef}
        style={{
          width: '100%',
          height: innerHeight,
          fontSize: announceFont || textFont,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'clip',
          lineHeight: 1.2,
        }}
      >
        <Announcement
          ref={announceRef}
          className="special-announcement"
          style={{
            height: '100%',
            fontSize: announceFont,
            whiteSpace: 'nowrap',
          }}
          fontSize={announceFont}
          accessibilityWidth={accessibilityWidth}
          wing={wing}
        />
      </div>
    </div>
  );
}